import "./carrier-header.css";

import { memo, useCallback, useState } from "react";

import { SortDropdown } from "~/shared/components/fields/sort-dropdown.tsx";
import type { CarrierPrice } from "~/shared/schemas/carrier-schema";
import type {
	CarrierFiltersType,
	FilterKey,
	SortDirection,
} from "~/shared/types/carrier-selection-types.ts";

import { tabs } from "../../constants/carrier-selection-constants.ts";
import { CarrierFilters } from "../carrier-filters/carrier-filters.tsx";

type CarrierHeaderProps = {
	carrierPrices: CarrierPrice[];
	onFilterChange: <K extends FilterKey>(
		key: K,
		value: CarrierFiltersType[K],
	) => void;
	onTabSelect: (tab: number) => void;
	onSortDirectionChange: (direction: SortDirection) => void;
	sortDirection: SortDirection;
};

export const CarrierHeader = memo(
	({
		carrierPrices,
		onFilterChange,
		onTabSelect,
		onSortDirectionChange,
		sortDirection,
	}: CarrierHeaderProps) => {
		const [selectedTabIndex, setSelectedTabIndex] = useState<number | null>(
			null,
		);
		const tabTitles = tabs.map((tab) => tab.title);

		const handleSortChange = useCallback(
			(event: { value: string }) => {
				const selectedIndex = tabTitles.indexOf(event.value);
				if (selectedIndex !== -1) {
					setSelectedTabIndex(selectedIndex);
					onTabSelect(selectedIndex);
				}
			},
			[tabTitles, onTabSelect],
		);

		const selectedSortValue =
			selectedTabIndex === null ? null : tabTitles[selectedTabIndex];

		return (
			<div className={"carrier-header"}>
				<CarrierFilters
					carrierPrices={carrierPrices}
					onFilterChange={onFilterChange}
				/>

				<SortDropdown
					data={tabTitles}
					defaultItem={"Sort by"}
					id={"sort-dropdown"}
					initialSortDirection={sortDirection}
					onChange={handleSortChange}
					onSortDirectionChange={onSortDirectionChange}
					value={selectedSortValue}
				/>
			</div>
		);
	},
);

CarrierHeader.displayName = "CarrierHeader";
